// src/components/PackingLists/EditPhotoModal.js
import React from 'react';
import Modal from '../Modal';
import ListForm from './ListForm';

/**
 * EditPhotoModal component provides UI for editing the list photo and details
 * 
 * @param {Object} props - Component props
 * @param {boolean} props.isOpen - Whether the modal is open
 * @param {Function} props.onClose - Function to close the modal
 * @param {Object} props.editingList - List being edited
 * @param {Function} props.setEditingList - Function to update the editing list
 * @param {Function} props.savePhotoChanges - Function to save photo and list changes
 * @returns {JSX.Element} Rendered component
 */
const EditPhotoModal = ({
  isOpen,
  onClose,
  editingList,
  setEditingList,
  savePhotoChanges
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Edit List Details"
    >
      <div className="edit-photo-modal">
        <ListForm
          list={editingList}
          setList={setEditingList}
          onSubmit={savePhotoChanges}
          onCancel={onClose}
          submitButtonText="Save Changes"
          isEdit={true}
        />
      </div>
    </Modal>
  );
};

export default EditPhotoModal;